import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 42C10.8954 42 10 41.1046 10 40V8C10 6.89543 10.8954 6 12 6H28.3077V14.125C28.3077 15.2296 29.2031 16.125 30.3077 16.125H38V40C38 41.1046 37.1046 42 36 42H12Z",
      fill: "#69D3A7"
    }, null, -1),
    _createElementVNode("path", {
      d: "M38 16.125L28.3077 6V14.125C28.3077 15.2296 29.2031 16.125 30.3077 16.125H38Z",
      fill: "#00595D"
    }, null, -1),
    _createElementVNode("path", {
      d: "M24 25V35M24 35L28 31M24 35L20 31",
      stroke: "#00595D",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }